import { render, staticRenderFns } from "./TableAction.vue?vue&type=template&id=4754444c&scoped=true&"
import script from "./TableAction.vue?vue&type=script&lang=js&"
export * from "./TableAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4754444c",
  null
  
)

export default component.exports